import { SidebarContainer, SidebarWrapper, ReviewsWrapper, SectionWrapper } from './articleSidebar.styled';
import TrustRating from '@components/views/cards/productCard/trustRating/TrustRating';
import { useACF } from '@context/ACFContext';
import { PostTemplate, MainProduct } from 'types/globalTypes';
import RatingList from '@components/views/cards/productCard/ratingList/RatingList';
import ConsCross from '@assets/icons/ConsCross';
import ProsCheckmark from '@assets/icons/ProsCheckmark';
import FeatureList from '@components/views/cards/productCard/featureList/FeatureList';
import { Button } from '@components/core/button/Button';

const ArticleSideBar: React.FC = () => {
	const { postTemplate } = useACF() as { postTemplate?: PostTemplate };
	const main = postTemplate?.review_page_v4_products_section_settings.main_product;

	if (!postTemplate) return null;

	const mainProduct: MainProduct | undefined = postTemplate.review_page_v4_products_section_settings?.main_product;
	if (!mainProduct) return null;

	if (!main) return null;

	const { product_pros, product_cons, tr_cons_label, tr_pros_label, rating_bar_color, rating_bar_background_color } =
		mainProduct;

	const {
		trust_pilot_rating_image,
		tr_trust_pilot_review_score_label,
		tr_trust_pilot_excellent_label,
		tr_trust_pilot_customer_reviews_label,
		trust_pilot_rating_score,
	} = mainProduct.trustpilot_component;

	const { tr_button_text, button_cta_link } = mainProduct.button_component;

	return (
		<SidebarContainer>
			<SidebarWrapper>
				<SectionWrapper>
					<ReviewsWrapper>
						<TrustRating
							reviewLabel={tr_trust_pilot_review_score_label}
							reviewScore={trust_pilot_rating_score}
							reviewEvaluation={tr_trust_pilot_excellent_label}
							reviewCount={tr_trust_pilot_customer_reviews_label}
							reviewImage={trust_pilot_rating_image}
							modifiers={{ marginBottom: '0px' }}
						/>
					</ReviewsWrapper>
				</SectionWrapper>
				<SectionWrapper>
					<RatingList
						$barBackground={rating_bar_background_color}
						$barColor={rating_bar_color}
						ratingRepeater={main.rating_repeater}
						prosRepeater={main.product_pros}
						consRepeater={main.product_cons}
						reviewScoreLabel={main.tr_review_score_label}
					/>
				</SectionWrapper>
				<SectionWrapper>
					<FeatureList
						modifiers={{ fontSize: '16px', lineHeight: '19px' }}
						data={product_pros && product_pros?.map((item) => ({ label: item.tr_product_pro }))}
						title={tr_pros_label}
						icon={<ProsCheckmark />}
						color="#00a871"
					/>
				</SectionWrapper>
				<SectionWrapper>
					<FeatureList
						modifiers={{ fontSize: '16px', lineHeight: '19px' }}
						data={product_cons && product_cons?.map((item) => ({ label: item.tr_product_con }))}
						title={tr_cons_label}
						icon={<ConsCross />}
						color="#D2152D"
					/>
				</SectionWrapper>
				<Button
					href={button_cta_link.url}
					target={button_cta_link.target === '_blank' ? '_blank' : '_self'}
					primary={true}
				>
					{tr_button_text}
				</Button>
			</SidebarWrapper>
		</SidebarContainer>
	);
};

export default ArticleSideBar;
